// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.item-list-toolbar-right1 {
  margin-right: auto;
  display: flex;
  align-items:start;
  gap: 0.5rem;
  margin-top: 40px;
}

.item-list-toolbar-right {
  margin-left: auto;
  display: flex;
  align-items:center;
  gap: 0.5rem;
  margin-top: 40px;
}

.item-list-tab {
  height: 40px;
  padding: 0 15px;

  border: 0;
  border-radius: 0px;

  background: #ffff;
  color: "#f0000";

  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
}

.item-list-tab:hover {
  background: #f7eef2;
}

.item-list-tab:active {
  background: #efe2e8;
  transform: translateY(1px);
}

.item-list-tab:focus-visible {
  outline: 2px solid rgba(227, 35, 35, 0.35);
  outline-offset: 2px;
}

.item-list-tab.is-active {
  background: #efe2e8;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
}

.item-list-grid-wrapper1 {
  flex: 1;
  min-height: 350px;
  width: 500px;
  height: 100%;
  margin-bottom: 50px;
}

.inv-modal-overlay2 {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.inv-modal2 {
  width: 400px;
  background: #fff;
  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);
  padding: 20px;
}`, "",{"version":3,"sources":["webpack://./src/web/component/ListsSettings/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;;EAEf,SAAS;EACT,kBAAkB;;EAElB,iBAAiB;EACjB,eAAe;;EAEf,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,OAAO;EACP,iBAAiB;EACjB,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0CAA0C;EAC1C,aAAa;AACf","sourcesContent":[".item-list-toolbar-right1 {\r\n  margin-right: auto;\r\n  display: flex;\r\n  align-items:start;\r\n  gap: 0.5rem;\r\n  margin-top: 40px;\r\n}\r\n\r\n.item-list-toolbar-right {\r\n  margin-left: auto;\r\n  display: flex;\r\n  align-items:center;\r\n  gap: 0.5rem;\r\n  margin-top: 40px;\r\n}\r\n\r\n.item-list-tab {\r\n  height: 40px;\r\n  padding: 0 15px;\r\n\r\n  border: 0;\r\n  border-radius: 0px;\r\n\r\n  background: #ffff;\r\n  color: \"#f0000\";\r\n\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n}\r\n\r\n.item-list-tab:hover {\r\n  background: #f7eef2;\r\n}\r\n\r\n.item-list-tab:active {\r\n  background: #efe2e8;\r\n  transform: translateY(1px);\r\n}\r\n\r\n.item-list-tab:focus-visible {\r\n  outline: 2px solid rgba(227, 35, 35, 0.35);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.item-list-tab.is-active {\r\n  background: #efe2e8;\r\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);\r\n}\r\n\r\n.item-list-grid-wrapper1 {\r\n  flex: 1;\r\n  min-height: 350px;\r\n  width: 500px;\r\n  height: 100%;\r\n  margin-bottom: 50px;\r\n}\r\n\r\n.inv-modal-overlay2 {\r\n  position: fixed;\r\n  inset: 0;\r\n  background: rgba(0, 0, 0, .45);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  z-index: 9999;\r\n}\r\n\r\n.inv-modal2 {\r\n  width: 400px;\r\n  background: #fff;\r\n  box-shadow: 0 10px 30px rgba(0, 0, 0, .25);\r\n  padding: 20px;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
